import React from "react";
import classnames from "classnames";
import classBind from "classnames/bind";

import styles from "./styles.scss";

let cx = classBind.bind(styles);

export default class Button extends React.Component {
  constructor(props) {
    super(props);

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick(e) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    const type = this.props.type || "button";
    const style = this.props.style;
    const block = this.props.block;

    let className = cx({
      button: true,
      [`${style}`]: true,
      [`${type}`]: true,
      block: block,
    });

    return (
      <button
        className={classnames(className)}
        onClick={this.handleOnClick}
        type={type}
        disabled={this.props.disabled}
      >
        {this.props.buttonText}
      </button>
    );
  }
}
